import { useCallback, useEffect, useRef } from 'react';

import { useXanoChannelsStore } from '@/services/xano';
import { RealtimeMessage } from '@/types/realtime-xano';

export function useXanoChannel<T>(
  channelName: string | null,
  onMessage: (data: RealtimeMessage<T>) => void
) {
  const { addListener, removeListener, addChannel, removeChannel } =
    useXanoChannelsStore();
  const onMessageRef = useRef(onMessage);

  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);

  const handleMessage = useCallback((data: RealtimeMessage<T>) => {
    onMessageRef.current(data);
  }, []);

  useEffect(() => {
    if (!channelName) return;

    addChannel(channelName);

    return () => {
      removeChannel(channelName);
    };
  }, [channelName, addChannel, removeChannel]);

  useEffect(() => {
    if (!channelName) return;

    addListener(channelName, handleMessage);

    return () => {
      removeListener(channelName, handleMessage);
    };
  }, [channelName, addListener, removeListener, handleMessage]);
}
